<template>
	<v-dialog v-model="dialog" persistent max-width="450px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" 
				dark small v-on="on">
				{{'sell franchise' | localize}}
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Define the franchise sale parameters' | localize}}
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list>
					<div v-if="canSelling"> 
						<v-form v-model="valid" ref="form" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-select dense
										v-model="name"
										:items="items"
										item-text="name"
										attach
										color="secondary"
										item-color="secondary"
										:label="'Select franchise' | localize"
										@change="onceMore()"
										:rules="[rules.required]">
									</v-select>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										color="secondary"
										:label="'Franchise cost' | localize"
										v-model.number="franchise_cost"
										name="franchiseCost"
										type="text"
										:rules="[rules.number]"
										@change="onceMore">
									</v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										color="secondary"
										:label="'Franchise fee' | localize"
										v-model.number="franchise_fee"
										name="franchiseFee"
										type="text"
										:rules="[rules.number]"
										@change="onceMore">
									</v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</div> 
					<v-row v-else class="text-center ma-2">
						{{ 'Unfortunately, the franchise cannot be sold this year' | localize }}&#129402;
					</v-row>
				</v-container>
				<v-row v-if="error" class="text-center mx-2 error--text">{{'Error' | localize }} => {{ error }} &#128533;</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!valid || !canSelling || Boolean(error)"
					@click="addChannel">
					{{'Save' | localize}}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" 
					@click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>	
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter';

	export default {
		props: ['outlets'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				rules: {
					required: v => (v && v.length > 0) || localizeFilter('required field'),
					number: v => {
						if (!isNaN(parseFloat(v)) && v >= 0) return true;
						return localizeFilter('its expected number more than 0');
					}
				},
				//props
				name: '',
				franchise_cost: 0,
				franchise_fee: 0,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			canSelling () {
				const sales = this.outlets.filter(outlet => outlet.sales_last > 0)
				return Boolean(this.outlets.length > 0 && sales.length > 0)
			},
			channels() {
				return this.$store.getters.channels;
			},
			items () {
				const frs = []
				this.outlets.forEach(outlet => {
					outlet.trademarks.map((trademark) => {
						const inChan = this.channels.find((item) => (item.type == 4 && item.name.split(' ')[0] == trademark.name));
						if (!inChan) {
							frs.push({name: (trademark.name + ' franchise'), trademark: [trademark.name]})
						}	
					});
				})
				return frs;
			}
		},
		methods: {
			onceMore () {
				this.error = ''
			},
			async addChannel () {
				
				if (this.$refs.form.validate()) {

					const item = this.items.find(it => it.name === this.name)
					
					const chan = {
						gameId: this.outlets[0].gameId,
						round: this.outlets[0].round,
						register_round: this.outlets[0].round,
						teamId: this.outlets[0].teamId,
						name: this.name,
						type: 4, //franchise
						stores: 0,
						franchise_cost: this.franchise_cost,
						franchise_fee: this.franchise_fee,
						trademarks: item.trademark,
						investment_costs: 0,
						operational_costs: 0,
						team: this.outlets[0].team,
					}
					//console.log(chan)
					await this.$store.dispatch('addChannel', chan)
					this.closeDialog ()					
				}
				else {
					this.error = 'Enter all params correctly, please'
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
	}
</script>
